// extracted by mini-css-extract-plugin
export default {"wrapper":"header_wrapper__didg0","logo":"header_logo__TmkQW"};